import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { useState } from "react";
import { Button } from "../ui/button";
import ReferralsList from "../ReferralsList";
import { useTranslation } from "@/hooks/useTranslation";
import CopyReferralCode from "./CopyReferralCode";
import { MailIcon } from "lucide-react";

export default function ReferAndEarnButton() {
  const t = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        className="p-8 pl-6 rounded-3xl items-center"
        onClick={() => setOpen(true)}
      >
        <MailIcon className="w-6 h-6 mr-2" />
        {t.REFER_AND_EARN.LABELS.BUTTON_TITLE}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="dark text-white px-4 sm:px-6 max-h-[80vh] overflow-auto">
          <DialogHeader>
            <DialogTitle className="text-left text-xl flex flex-row">
              {t.REFER_AND_EARN.LABELS.CARD_TITLE}
            </DialogTitle>
            <DialogDescription className="flex flex-col gap-4 text-left">
              {t.REFER_AND_EARN.LABELS.DESCRIPTION}
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-row items-center mb-2">
            <CopyReferralCode />
          </div>
          <ReferralsList />
          <div className="text-sm text-zinc-400">
            {t.REFER_AND_EARN.LABELS.NO_GUARANTEE}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
